var map = {
	"./credentials_leak.svg": 79921,
	"./fraudulent_activity.svg": 59055,
	"./impersonation_attempt.svg": 62189,
	"./new_domain_registered.svg": 54659,
	"./new_email_address.svg": 96821,
	"./new_hostname_found.svg": 18966,
	"./new_ssl_certificate_found.svg": 68895,
	"./new_vulnerability.svg": 51762,
	"./new_vulnerable_asset_found.svg": 99488,
	"./personal_information_exposure.svg": 48354,
	"./potential_phishing.svg": 47728,
	"./targeting_disclosure.svg": 97522,
	"./underground_activity.svg": 56412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6166;